import $ from 'jquery';

const gallery = (element, index) => {
    const $items = element.find('.blocks-gallery-item');
    const $visible = $items.filter(function () {
        return $(this).is(':visible');
    });
    const hiddenCount = $items.length - $visible.length;

    hiddenCount || $items.length >= 5
        ? element.addClass('wp-block-gallery--overflow')
        : element.removeClass('wp-block-gallery--overflow');

    if (hiddenCount) {
        let label;

        switch (hiddenCount) {
            case 1:
                label = 'fotka';
                break;
            case 2:
            case 3:
            case 4:
                label = 'fotky';
                break;
            default:
                label = 'fotek';
                break;
        }

        const $lastVisible = $visible.last();

        $lastVisible.find('.item-counter').length === 0 &&
            $lastVisible.css('position', 'relative').prepend(`
                <div class="item-counter">
                    <div>
                        <div>
                            +${hiddenCount}
                        </div>
                        <div>
                            ${label}
                        </div>
                    </div>
                </div>
            `);
    } else {
        $visible.last().css('position', '').find('.item-counter').remove();
    }
};

export const reloadScriptWpBlockGallery = () => {
    const $element = $('.wp-block-gallery');

    if ($element.length > 0) {
        $element.each(function (index) {
            gallery($(this), index);
        });
    }
};
reloadScriptWpBlockGallery();
